import React from 'react';
import { formatDateTime } from '../../utils/dateTimeUtils';

const HumanDateTime = ({ value }) => <span>{formatDateTime(value)}</span>;

export default HumanDateTime;